export default "__VITE_ASSET__0401395f__"